import { Redirect } from 'aurelia-router';
/**
 * This container is integrated with `appSession` service in order to perform a user
 * authentication with the Olapic SSO.
 */
class LoginContainer {
  /**
   * @param {Router}          router          To validate if the user can access the container or
   *                                          if he/she should be redirected to the home route.
   * @param {AppErrorHandler} appErrorHandler In case the authentication process fails.
   * @param {AppSession}      appSession      To actually invoke the authentication process.
   */
  constructor(router, appErrorHandler, appSession) {
    'inject';

    /**
     * A local reference for the `router` service.
     * @type {Router}
     * @access protected
     */
    this._router = router;
    /**
     * A local reference for the `appErrorHandler` service.
     * @type {AppErrorHandler}
     * @access protected
     */
    this._appErrorHandler = appErrorHandler;
    /**
     * A local reference for the `appSession` service.
     * @type {AppSession}
     * @access protected
     */
    this._appSession = appSession;
  }
  /**
   * Triggers the authentication process.
   */
  activate() {
    this._appSession.authenticate()
    .catch((error) => {
      this._appErrorHandler.handle(error);
    })
    .then(() => {
      this._router.navigateToRoute('home');
    });
  }
  /**
   * Validates if the user is authenticated in order to prevent him/her from accessing the
   * container.
   * @return {Boolean|Redirect}
   */
  canActivate() {
    let result = true;
    if (this._appSession.isAuthenticated()) {
      result = new Redirect(this._router.generate('home'));
    }

    return result;
  }
}

export { LoginContainer };
